import { render, staticRenderFns } from "./KontaktUns.vue?vue&type=template&id=c6fb708a&scoped=true&"
import script from "./KontaktUns.vue?vue&type=script&lang=js&"
export * from "./KontaktUns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fb708a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VImg,VTextarea})
